import Box from '@redbubble/design-system/src/Box';
import styles from './ImageProtection.module.scss';

interface ImageProtectionProps {
  children: React.ReactNode;
}

export const ImageProtection: React.FC<ImageProtectionProps> = ({
  children,
}) => {
  return (
    <Box className={styles.imageFrame}>
      {children}
      <Box className={styles.imageOverlay} />
    </Box>
  );
};
